import { BaseService } from "./base.service";

import {
	IOrganizationLogoModel,
	OrganizationDetail,
	OrganizationGlSegmentModel,
} from "models/OrganizationDetail";
import { IBudgetCheckLevel } from "models/BudgetCheckLevelModel";
import { IErpDbCompany } from "models/ErpDbCompanyModel";

class OrganizationServiceInternal extends BaseService {
	getOrganizationDetails = async (): Promise<OrganizationDetail> =>
		this.callApi<OrganizationDetail>(
			`Organization/GetOrganizationDetails`,
			"GET"
		);

	getBudgetCheckLevelList = async (): Promise<IBudgetCheckLevel[]> =>
		this.callApi<IBudgetCheckLevel[]>(`BudgetCheckLevel/GetAll`, "GET");

	updateOrganizationDetail = async (
		organizationDetailModel: OrganizationDetail
	): Promise<number> =>
		this.callApi<number>(
			`Organization/Update/${organizationDetailModel.organizationId}`,
			"POST",
			undefined,
			organizationDetailModel
		);

	uploadOrganizationLogo = async (
		organizationId: number,
		formData: FormData
	): Promise<IOrganizationLogoModel> =>
		this.callApi<IOrganizationLogoModel>(
			`Organization/UploadAttachment/${organizationId}`,
			"POST",
			undefined,
			formData,
			false,
			true
		);

	saveUpdateGlSegment = async (
		model: OrganizationGlSegmentModel
	): Promise<undefined> =>
		this.callApi<undefined>(
			`OrganizationGlSegment/SaveUpdateAll`,
			"POST",
			undefined,
			model
		);

	getGlSegmentByErpDbCompany = async (
		erpDbCompanyId: number
	): Promise<OrganizationGlSegmentModel> =>
		this.callApi<OrganizationGlSegmentModel>(
			`OrganizationGlSegment/GetByErpDbCompanyId/${erpDbCompanyId}`,
			"GET"
		);

	getErpDbCompanyListByGlSegment = async (
		glSegmentId: number
	): Promise<IErpDbCompany[]> =>
		this.callApi<IErpDbCompany[]>(
			`OrganizationGlSegment/GetErpDbCompanyList/${glSegmentId}`,
			"GET"
		);

	getOrganizationBrandingDetails = async (): Promise<Pick<
		OrganizationDetail,
		"organizationLogo" | "name" | "filePath"
	> | null> =>
		this.callApi<Pick<
			OrganizationDetail,
			"organizationLogo" | "name" | "filePath"
		> | null>(
			`Organization/GetOrganizationBrandingDetails`,
			"GET",
			undefined,
			undefined,
			undefined,
			undefined,
			false
		);
}

export const OrganizationService = new OrganizationServiceInternal();
